import AxiosInstance from "./api";

export const ValueAddedTaxRefundService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/value-added-tax-refund/paginate", {
      params: query,
    });
  },

  getInit: async () => {
    return await AxiosInstance.get("/private/value-added-tax-refund/init");
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/value-added-tax-refund/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/value-added-tax-refund", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.put("/private/value-added-tax-refund/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/value-added-tax-refund/" + id);
  },
};
